module.exports = __webpack_public_path__ + "img/stock7.bf835e0f.png";